export default __webpack_public_path__ + "static/media/0000..0001.d78f1b29.png";